import { Component, Input, EventEmitter, Output } from "@angular/core";

@Component({
    selector: "text-filter-option",
    templateUrl: "./textFilterOption.component.html",
    styleUrls: ["./textFilterOption.component.css"],
    standalone: false
})
export class TextFilterOptionComponent {
    @Input() public text: string;
    @Input() public showSeparator: boolean;
    @Input() public checked: boolean = false;
    @Output() public stateChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    public toggleState(): void {
        this.checked = !this.checked;
        this.stateChanged.emit(this.checked);
    }
}